import axios from 'axios';
import Vue from 'vue';
import Vuex from 'vuex';
import VuexORM from '@vuex-orm/core';
import VuexORMAxios from '@vuex-orm/plugin-axios';

import Availability from '@/models/Availability';
import Bathroom from '@/models/Bathroom';
import Bedroom from '@/models/Bedroom';
import Section from '@/models/Section';
import Sectionable from '@/models/Sectionable';
import CalculatorSettings from '@/models/CalculatorSettings';
import Date from '@/models/Date';
import Facility from '@/models/Facility';
import FacilityResidence from '@/models/FacilityResidence';
import Facts from '@/models/Facts';
import File from '@/models/File';
import Illustration from '@/models/Illustration';
import Image from '@/models/Image';
import Imageable from '@/models/Imageable';
import ImageSize from '@/models/ImageSize';
import Level from '@/models/Level';
import Levelable from '@/models/Levelable';
import Link from '@/models/Link';
import Option from '@/models/Option';
import OptionCategory from '@/models/OptionCategory';
import OptionVariable from '@/models/OptionVariable';
import Project from '@/models/Project';
import Projectable from '@/models/Projectable';
import Residence from '@/models/Residence';
import ResidenceType from '@/models/ResidenceType';
import Selector from '@/models/Selector';
import Setting from '@/models/Setting';
import Shape from '@/models/Shape';

import each from 'lodash/each';

Vue.use(Vuex, each);
VuexORM.use(VuexORMAxios, { axios });

// Create a new instance of Database.
const database = new VuexORM.Database();

// Register Models to Database.
database.register(Availability);
database.register(Bathroom);
database.register(Bedroom);
database.register(Section);
database.register(Sectionable);
database.register(CalculatorSettings);
database.register(Date);
database.register(Facility);
database.register(FacilityResidence);
database.register(Facts);
database.register(File);
database.register(Illustration);
database.register(Image);
database.register(Imageable);
database.register(ImageSize);
database.register(Project);
database.register(Level);
database.register(Levelable);
database.register(Link);
database.register(Option);
database.register(OptionCategory);
database.register(OptionVariable);
database.register(Projectable);
database.register(Residence);
database.register(ResidenceType);
database.register(Selector);
database.register(Setting);
database.register(Shape);

export default new Vuex.Store({
  plugins: [VuexORM.install(database)],
  state: {},
  mutations: {},
  actions: {},
  getters: {},
});
